import { NgModule } from '@angular/core';

import { LayoutContainerComponent } from './layout-container/layout-container.component';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { NotFoundComponent } from '../session/not-found/not-found.component';
import { PatientLayoutComponent } from './patient-layout/patient-layout.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { SessionModule } from '../session/session.module';
import { InactiveNotificationDialogComponent } from './inactive-notification-dialog/inactive-notification-dialog.component';
import { RedirectToNiceAdminGuard } from '../core/guards/nice-admin-redirect.guard';
import { environment } from '../../environments/environment';
import { HomeVisitRequestIntakeLayoutComponent } from './home-visit-request-intake-layout/home-visit-request-intake-layout.component';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'patient',
        loadChildren: () => import('../patient/patient.module').then((m) => m.PatientModule),
      },
      {
        path: 'provider',
        loadChildren: () => import('../provider/provider.module').then((m) => m.ProviderModule),
      },
      {
        path: 'membership',
        loadChildren: () => import('../membership/membership.module').then((m) => m.MembershipModule),
      },
      {
        path: 'company',
        canActivate: [RedirectToNiceAdminGuard],
        data: {
          target: environment.niceAdminUrl + '/clients',
          componentRedirect: false,
        },
        component: DashboardLayoutComponent,
      },
      {
        path: 'schedule',
        loadChildren: () => import('../schedule/schedule.module').then((m) => m.ScheduleModule),
      },
      {
        path: 'billing',
        canActivate: [RedirectToNiceAdminGuard],
        data: {
          target: environment.niceAdminUrl + '/billing',
          componentRedirect: false,
        },
        component: DashboardLayoutComponent,
      },
      {
        path: 'markets',
        loadChildren: () => import('../markets/markets.module').then((m) => m.MarketsModule),
      },
      {
        path: '404',
        component: NotFoundComponent,
      },
      {
        path: '',
        redirectTo: 'schedule',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'patients',
    component: PatientLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('../patient/patient.module').then((m) => m.PatientModule),
      },
      {
        path: 'documents',
        loadChildren: () => import('../documents/documents.module').then((m) => m.DocumentsModule),
      },
      {
        path: '404',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'home-visit-request-intake/:homeVisitRequestId',
    component: HomeVisitRequestIntakeLayoutComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  declarations: [
    DashboardLayoutComponent,
    LayoutContainerComponent,
    PatientLayoutComponent,
    HomeVisitRequestIntakeLayoutComponent,
    InactiveNotificationDialogComponent,
  ],
  imports: [RouterModule.forChild(routes), SharedModule, SessionModule],
  exports: [LayoutContainerComponent],
})
export class DashboardLayoutModule {}
